import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing.space4,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    transition: "all 0.3s",
    background: theme.colors.TextCharcoal,
    "&.active": {
      width: 24,
      height: 6,
      borderRadius: 3,
      background: "#fff",
    },
  },
}));
